module.exports = __webpack_public_path__ + "static/fonts/iconfont.c7d6d1b.eot";